export const MARGIN = {
    top: 40,
    right: 20,
    bottom: 80,
    left: 40,
};
export const BAR_PADDING = 0.3;
export const COLORS = {
    stroke: '#208FA1',
    fill: '#208FA1',
};
